import React from 'react';

const Loading = () => (
  <div className='spinner'>
    <img src={`${process.env.REACT_APP_CDNURL}/images/loader.gif`} alt='Loading' />
  </div>
);

export default Loading;
